import { useQuery } from '@tanstack/react-query';
import { useLocation } from '@/shared/hooks/useLocation';
import { callsApi } from '../api/callsApi';
import { callsKeys } from '../queryKeys';

export function useCallAgents() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';

  const query = useQuery({
    queryKey: callsKeys.agents(locationId),
    queryFn: () => callsApi.listAgents(locationId),
    enabled: !!locationId,
  });

  return { ...query, agents: query.data ?? [], locationId };
}
